import React from 'react'
import { Box, Heading, Text, Image } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql } from 'gatsby'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'

import theme from '../../lib/theme'

SwiperCore.use([Navigation])

const TestimonialsCard = () => {
  const { t } = useTranslation('home')
  const reports = t('reports.clients', { returnObjects: true })
  const data = useStaticQuery(graphql`
    query {
      depoiments: allFile(
        filter: { extension: { regex: "/png/" }, dir: { regex: "/depoiments/" } }
      ) {
        edges {
          node {
            id
            name
            publicURL
          }
        }
      }
    }
  `)

  return (
    <Box>
      <Swiper
        breakpoints={{
          // when window width is >= 320px
          320: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 24
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 40,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        }}
        style={{
          overflow: 'visible'
        }}
      >
        {reports.map((report) => (
          <SwiperSlide key={report}>
            <Box
              mt={[22, 22, 33]}
              pt={[15, 15, 20]}
              px={[5, 5, 10]}
              pb={[6, 6, 10]}
              bg="white"
              sx={{
                position: 'relative',
                boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
                borderRadius: '10px'
              }}
            >
              <Image
                src={
                  data.depoiments.edges.find(({ node }) => node.name.includes(report.client))?.node
                    .publicURL
                }
                width={['80px', '80px', '104px']}
                sx={{
                  position: 'absolute',
                  top: '-44px',
                  left: '20px'
                }}
              />

              <Box width={[1, 1, '335px']}>
                <Text
                  variant="level3"
                  fontSize={theme.customFontsize(14, 22)}
                  fontWeight="400"
                  lineHeight="145%"
                  color="#0A2540"
                >
                  {report.text}
                </Text>

                <Heading
                  as="h4"
                  mt={8}
                  mb={1}
                  variant="level3"
                  fontSize={theme.customFontsize(16, 18)}
                  letterSpacing="0px"
                  lineHeight="150%"
                >
                  {report.client}
                </Heading>
                <Text
                  as="p"
                  variant="level6"
                  fontSize={theme.customFontsize(12, 14)}
                  letterSpacing="0px"
                  lineHeight="150%"
                >
                  {report.position}
                </Text>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )
}

export default TestimonialsCard
